// Live frontend edit bar (Elementor-style) for logged-in editors.
// Provides fetch helpers for the code panel + custom-JS injection for all visitors.
(function () {
    if (window.__pdEditBar) return;

    window.__pdEditBar = {
        // Returns a JSON string: { ok, error, html, htmlEditable, css, js }
        load: async function (id) {
            try {
                const r = await fetch('/api/pagebuilder/code/' + encodeURIComponent(id), {
                    credentials: 'same-origin',
                    headers: { 'Accept': 'application/json' }
                });
                const text = await r.text();
                if (!r.ok) {
                    return JSON.stringify({ ok: false, error: 'HTTP ' + r.status });
                }
                let data;
                try { data = JSON.parse(text); }
                catch (e) { return JSON.stringify({ ok: false, error: 'Réponse non-JSON (session expirée ?)' }); }
                data.ok = true;
                return JSON.stringify(data);
            } catch (e) {
                return JSON.stringify({ ok: false, error: (e && e.message) || 'Erreur réseau' });
            }
        },

        // Returns a JSON string: { ok, error, published }
        save: async function (id, payloadJson) {
            try {
                const r = await fetch('/api/pagebuilder/save-code/' + encodeURIComponent(id), {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' },
                    body: payloadJson
                });
                const text = await r.text();
                let data = {};
                try { data = JSON.parse(text); } catch (e) { }
                if (!r.ok) {
                    return JSON.stringify({ ok: false, error: data.error || ('HTTP ' + r.status) });
                }
                data.ok = true;
                return JSON.stringify(data);
            } catch (e) {
                return JSON.stringify({ ok: false, error: (e && e.message) || 'Erreur réseau' });
            }
        },

        // Code panel (PageEditBar): fills the three editors over HTTP. Returns a SMALL object
        // { ok, error, htmlEditable } — the code itself never travels through the circuit.
        openPanel: async function (id) {
            const res = JSON.parse(await this.load(id));
            if (!res.ok) return { ok: false, error: /404/.test(res.error || '') ? '404' : res.error, htmlEditable: false };
            // The panel's render batch normally lands before this call; wait a few frames if not.
            for (let i = 0; i < 30 && !document.getElementById('pd-codepanel-css'); i++)
                await new Promise(r => requestAnimationFrame(r));
            const set = (key, value) => {
                const ta = document.getElementById('pd-codepanel-' + key);
                if (!ta) return;
                ta.value = value || '';
                ta.defaultValue = value || ''; // baseline for "changed?" on save
            };
            set('html', res.html); set('css', res.css); set('js', res.js);
            return { ok: true, error: null, htmlEditable: !!res.htmlEditable };
        },

        // Saves the three editors over HTTP. Returns { ok, error, published }.
        savePanel: async function (id, publish, htmlEditable) {
            const value = key => { const ta = document.getElementById('pd-codepanel-' + key); return ta ? ta.value : null; };
            const htmlTa = document.getElementById('pd-codepanel-html');
            const payload = {
                css: value('css'),
                js: value('js'),
                html: value('html'),
                htmlChanged: !!htmlEditable && !!htmlTa && htmlTa.value !== htmlTa.defaultValue,
                publish: !!publish
            };
            const res = JSON.parse(await this.save(id, JSON.stringify(payload)));
            return { ok: !!res.ok, error: res.error || null, published: !!res.published };
        },

        reload: function () { location.reload(); }
    };

    // Inject (or replace) the page's custom JS — runs for every visitor.
    window.__pdInjectPageJs = function (js) {
        const id = 'pd-custom-page-js';
        const old = document.getElementById(id);
        if (old) old.remove();
        if (!js || !js.trim()) return;
        const s = document.createElement('script');
        s.id = id;
        s.textContent = js;
        document.body.appendChild(s);
    };
})();
